export default class XResizeContainer
{
    #resizeObserver;
    #objects = new Set();

    constructor(...elementsToObserve)
    {
        this.#resizeObserver = new ResizeObserver(() =>
        {
            for(const object of this.#objects)
            {
                object._handleResize();
            }
        });
        for(const element of elementsToObserve)
        {
            this.#resizeObserver.observe(element);
        }
    }

    add(object, handleResize=false)
    {
        this.#objects.add(object);
        object._resizeContainer = this;
        if(handleResize)
        {
            object._handleResize();
        }
    }

    remove(object)
    {
        return this.#objects.delete(object);
    }

    destroy()
    {
        this.#resizeObserver.disconnect();
        for(const object of this.#objects)
        {
            delete object._resizeContainer;
        }
        this.#objects.clear();
    }
}
